<div *ngIf="showPreview()" style="height: 200px; border-bottom-left-radius: 0; border-bottom-right-radius: 0;"
     class="d-flex justify-content-center align-items-center overflow-hidden card-border-radius ">
  <sb-preview-tooltip [thumbnailSize]="'S'" [customHeight]="'100%'" [customWidth]="'378px'"
                      [previews]="previews"></sb-preview-tooltip>
</div>
<div class="p-3">
  <div class="d-flex align-items-center pb-2">
    <sb-planning-status *ngIf="commercialEvent?.data?.commercial?.booking?.planning" class="mr-2"
                        [booking]="commercialEvent?.data?.commercial"></sb-planning-status>
    <h5 class="font-weight-bold" [innerHTML]="commercialEvent?.name | truncate : 35"></h5>
  </div>
  <div class="d-flex justify-content-between align-items-center">
    <sb-time-status type="big" [booking]="commercialEvent?.data?.commercial"></sb-time-status>
    <sb-cull-preview [playerAggregationData]="commercialEvent?.data?.commercial?.playerAggregation"></sb-cull-preview>
  </div>
  <div class="d-flex justify-content-between align-items-center">
    <sb-action-required class="red font-weight-bold" [messagesInline]="true"
                        [bookingStatus]="commercialEvent?.data?.commercial?.bookingStatus"></sb-action-required>
  </div>
  <ng-content></ng-content>
</div>

